import { gql } from '@apollo/client';

export const GENERATE_DETAILED_DATA_REPORT_FILE_URL = gql`
  mutation GenerateDetailedDataReportFileUrl(
    $reportData: DetailedDataReportFileUrlInput!
    $sortOptions: SortOptions
    $searchTerm: String
  ) {
    generateDetailedDataReportFileUrl(reportData: $reportData, sortOptions: $sortOptions, searchTerm: $searchTerm)
  }
`;
